import type { ComponentProps } from "react"

import { cn } from "@productlane/lib/src/browser"

export function PrefillRow({
	className,
	children,
	...props
}: ComponentProps<"button">) {
	return (
		<button
			{...props}
			className={cn(
				"group relative flex w-full cursor-pointer items-center rounded-md border p-4 hover:bg-gray-100 dark:hover:bg-gray-800",
				className,
			)}
		>
			<div>{children}</div>
			<div className="absolute inset-y-0 right-2 flex items-center rounded-md bg-gray-100 p-2 text-sm font-medium text-secondary opacity-0 group-hover:opacity-100 dark:bg-gray-800">
				↓ Prefill
			</div>
		</button>
	)
}
